<template>
    <properties-block v-bind="$props" v-on="$listeners">
        <properties-component-link title="Link|Lien" :value="block.link" v-bind="componentProps"/>

        <template #layout>
            <!-- Nothing here -->
        </template>
    </properties-block>
</template>

<script>
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";
import PropertiesComponentLink from "@components/editor/properties/components/properties-component-link.vue";
import CmsBlock from "@components/editor/rendering/blocks/cms-block.vue";

// properties-block-container #hot-reload-debug
export default {
    name: `properties-block-container`,
    components: {CmsBlock, PropertiesComponentLink, PropertiesBlock},
    extends: PropertiesBlock
}
</script>

<style lang="scss" scoped>
</style>
